import React from "react";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";

const LogoutButton = () => {
    const handleLogout = async () => {
        try {
            await signOut(auth);
            alert("Вы вышли из аккаунта.");
        } catch (error) {
            console.error("Ошибка выхода:", error);
        }
    };

    return (
        <button
            onClick={handleLogout}

        >
            Выйти
        </button>
    );
};

export default LogoutButton;
